import { SpinnerService } from 'src/app/services/spinner.service';
import { setConfigTable, basicAlert, timerOut, alertaConfirmacion } from 'src/app/shared/utils';
import { Component, OnInit, ElementRef, ViewChild, OnDestroy, Input } from '@angular/core';
import { BuscarService } from 'src/app/services/buscar.service';
import { objClienteFrm } from 'src/app/modulos/archivos/interlocutor-comercial/cliente/cliente-nuevo/objConfiguracionCliente.model'
import { Cliente } from 'src/app/models/cliente.model';
import { ClienteService } from 'src/app/services/cliente.service'
import { VendedorService } from 'src/app/services/vendedor.service';
import * as moment from "moment";
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ClienteClase } from "src/app/models/ClienteClase.model";
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { ImportarSunatComponent } from 'src/app/shared/modals/importar-sunat/importar-sunat.component';
import { RecursosService } from 'src/app/services/recursos.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModificarClienteComponent } from './modificar-cliente/modificar-cliente.component';
import { NuevoClienteComponent } from './nuevo-cliente/nuevo-cliente.component';

@Component({
  selector: 'app-md-cliente-nuevo',
  templateUrl: './md-cliente-nuevo.component.html',
  styleUrls: ['./md-cliente-nuevo.component.css']
})
export class MdClienteNuevoComponent implements OnInit {
  @Input() codIntelocutor:any;
  vista: number = 1;
  constructor(
    private clienteService: ClienteService,
    private _buscarService: BuscarService,
    private spinnerService: SpinnerService,
    private VendedorService: VendedorService,
    private modalService: NgbModal,
    private interlocutorService: InterlocutorService,
    private recursosService: RecursosService,
    private toastr: ToastrService,
    private router: Router,
    private modalService2: NgbActiveModal,

  ) { }

  buscar_razonc = '';
  buscar_codcli = '';
  disabledInterlocutor: boolean = false;
  public buscarLimpiarBoton: string = 'buscar';
  public interlocutores: any[] = [];

  ngOnInit(): void {
    console.log('Este es el interlocutor',this.codIntelocutor);
    if(this.codIntelocutor!=null){
      this.getByCodInterlocutor(this.codIntelocutor,0);
    }
  }
  onKeyEnterCodInterlocutor(e: any) {
    this.onBlurCodInterlocutor(this.buscar_codcli);
  }
  onBlurCodInterlocutor(codcli: string) {
    if (codcli != null || codcli != '') {
      this.getByCodInterlocutor(codcli,1);
    }
  }
  onKeyEnterInterlocutorCodigo(e) {
    this.openModalInterlocutorCodigo();

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }
  onKeyEnterInterlocutor(e) {
    this.openModalInterlocutor();

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  getByCodInterlocutor(codcli: string,tipo: number) {

    this.spinnerService.activarLoading(true);
    this.interlocutorService.obtenerInterlocutor(codcli, null).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.disabledInterlocutor = true;
  

    }, err => {
      this.spinnerService.activarLoading(false);
      if (err.status == 404) {
        basicAlert('Cliente no encontrado', 'warning', 'Aceptar');
      }
      setTimeout(() => {
        //this.chRef.detectChanges();
        //this.funicionesTSIService.createTable('datatableContacto', false, true, '350px');
        //this.funicionesTSIService.createTable('datatableBancos', false, true, '350px');
        //this.funicionesTSIService.createTable('datatableDireccionesEnvio', false, true, '350px');
      }, 350);
    });

  }
  openModalInterlocutorCodigo() {
    //this.onChangeRadioButron()
    let codcli: string = this.buscar_codcli+'%';
    let razonc: string = this.buscar_razonc + "%";
    let nombres: string = this.buscar_razonc + "%";
    let dident: string = '';
    let soloactivos: boolean = false;
    let limit: number = 350;
    let offset: number = 0;


    // if (this.buscar_razonc.length > 0) {
      this.spinnerService.activarLoading(true);

      //this.funicionesTSIService.destroyTable('ModaldatatableInterlocutor');
      this.interlocutorService.buscarInterlocutorGeneral('',codcli, razonc, nombres, dident, soloactivos, limit, offset).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        this.interlocutores = response.body;

      }, err => {
        this.interlocutores=[]
        if (err.status == 404) {
          basicAlert('No se encontró la lista de clientes', 'warning', 'Aceptar', null, null);
        }
        this.spinnerService.activarLoading(false);
      });
    // } else {
    //   basicAlert('Para activar la ayuda ingresar mínimo 1 caracter', 'warning', 'Aceptar', null, null);
    //   return;
    // }
  }
  openModalInterlocutor() {
    //this.onChangeRadioButron()
    let codcli: string = this.buscar_codcli+'%';
    let razonc: string = this.buscar_razonc + "%";
    let nombres: string = this.buscar_razonc + "%";
    let dident: string = '';
    let soloactivos: boolean = false;
    let limit: number = 350;
    let offset: number = 0;


    // if (this.buscar_razonc.length > 0) {
      this.spinnerService.activarLoading(true);

      //this.funicionesTSIService.destroyTable('ModaldatatableInterlocutor');
      this.interlocutorService.buscarInterlocutor(codcli, razonc, nombres, dident, soloactivos, limit, offset).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        this.interlocutores = response.body;

      }, err => {
        this.interlocutores=[]
        if (err.status == 404) {
          basicAlert('No se encontró la lista de clientes', 'warning', 'Aceptar', null, null);
        }
        this.spinnerService.activarLoading(false);
      });
    // } else {
    //   basicAlert('Para activar la ayuda ingresar mínimo 1 caracter', 'warning', 'Aceptar', null, null);
    //   return;
    // }
  }
  verInsertar(){
    const referenciaModal = this.modalService.open(NuevoClienteComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
    // referenciaModal.result.then((data) => {
    //   console.log(" data devuelta");
    //   console.log(data);
    // }, (reason) => {
    //   console.log(reason);
    // });
  }
  abrirModificar(data) {
    const referenciaModal = this.modalService.open(ModificarClienteComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
    referenciaModal.componentInstance.codcli = data.codcli;
       referenciaModal.result.then((data) => {
       console.log("data devuelta",data);
        if(data){
          this.openModalInterlocutor();
        }
     }, (reason) => {
       console.log(reason);
   });
  }

  itemtemp
  onClick(data: any): void {
    this.itemtemp = data;
  }
  onNexFocus(){
    
  }

  cerrar(){
    this.modalService2.dismiss('canceling');
  }
}
